import React from 'react'
import { useState, useEffect } from 'react'
import dayjs from 'dayjs'
import { useGlobalState } from 'state'
import { TimeSeriesRow } from 'common/types'
import { TimeSeriesSlider } from 'components/layers/TimeSeriesSlider'
import * as api from 'common/api'
import { KouzuiNomalRiverLineLayer } from './KouzuiNomalRiverLineLayer'
import { LAYERS } from 'common/layers'
import { KouzuiKikikuruLayer } from './KouzuiKikikuruLayer'


export const KouzuiLayer = () => {
  const { app, map } = useGlobalState()
  const [sliderIndex, setSliderIndex] = useState(-1)
  const [sliderBaseDate, setSliderBaseDate] = useState<dayjs.Dayjs>(dayjs.utc())
  const [timeSeries, setTimeSeries] = useState<TimeSeriesRow[]>([])

  const layerIds = [LAYERS.KOUZUI_FORECAST.id, LAYERS.KOUZUI_RISK.id]
  const displayLabelsHours = [-3, -2, -1, 0]

  useEffect(() => {
    load()
  }, [timeSeries, sliderIndex])

  useEffect(() => {
    fetch()
  }, [app.baseDate])

  useEffect(() => {
    return () => {
      visibility(false)
    }
  }, [])

  const visibility = (bool: boolean) => {
    layerIds.forEach(layerId => map.setLayoutVisibility(layerId, bool))
  }

  const load = () => {
    if (timeSeries.length === 0 || sliderIndex < 0 || timeSeries.length <= sliderIndex) {
      visibility(false)
      return
    }

    const data = timeSeries[sliderIndex].url
    layerIds.forEach(layerId => {
      if (data && map.hasSource(layerId)) {
        map.updateSourceData(layerId, data)
        visibility(true)
      } else {
        visibility(false)
      }
    })
  }

  const fetch = async () => {
    const res = await api.get('/river-risk', {date: app.getFormattedBaseDate(5)})
    if (res === null) {
      return
    }
    const rows: any[] = res.riverRisks
    const baseDateIndex = rows.findIndex(row => row.date === res.baseDate)
    setTimeSeries(rows)
    setSliderIndex(baseDateIndex)
    setSliderBaseDate(dayjs.utc(rows[baseDateIndex].date))

    load()
  }

  const sliderMoveend = (index: number) => {
    setSliderIndex(index)
  }

  return (
    <>
      <KouzuiNomalRiverLineLayer />
      <KouzuiKikikuruLayer sliderIndex={sliderIndex} />
      <TimeSeriesSlider
        baseDate={sliderBaseDate}
        currentIndex={sliderIndex}
        timeSeries={timeSeries}
        displayLabelsHours={displayLabelsHours}
        moveend={sliderMoveend}
      />
    </>
  )
}
